import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CaretBottomRightCenter8Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1792 331v1461H331L1792 331zm-256 618l-587 587h587V949z" />
    </svg>
  ),
  displayName: 'CaretBottomRightCenter8Icon',
});

export default CaretBottomRightCenter8Icon;
